var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('carihareketbaseaktarim',{attrs:{"status":_vm.status,"menuitems":_vm.menuItems},on:{"submitfile":_vm.SubmitFile,"menuclick":_vm.menuClick},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }